import { BaseAPI } from "./BaseAPI";
import * as environment from '../config/environment';

class DuyurularAPI extends BaseAPI {
  constructor() {
    const baseUrl = environment.API_URL + "Duyurular";
    super(baseUrl);
  }

  getDuyurularListe() {
    return this.get("DuyurularListe");
  }

  saveDuyuru(data: any) {
    return this.post("DuyurularSave", data);
  }
}

export default new DuyurularAPI(); 